<template>

    <el-row>
        <el-row>
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item>
                    <el-select @change="loadList()" clearable placeholder="上架状态" v-model="formInline.state">
                        <el-option label="已上架" value="1"></el-option>
                        <el-option label="已下架" value="0"></el-option>
                        <el-option label="待上架" value="3"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item belong-to-admin>
                    <channel-select @change="channelIdsChange" clearable filterable placeholder="展示渠道"
                                    ref="channelSelect"></channel-select>
                </el-form-item>

                <el-form-item belong-to-admin>
                    <channel-select @change="channelIdsChangeClue" clearable filterable placeholder="展示渠道"
                                    ref="channelSelect"></channel-select>
                </el-form-item>

                <el-form-item>
                    <el-date-picker @change="loadList" end-placeholder="入驻截止时间" start-placeholder="入驻开始时间"
                                    type="daterange"
                                    v-model="formInline.createTime">
                    </el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-input placeholder="商家名称/地址/姓名/手机号/创建人" v-model="formInline.keyWord"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button @click="loadList" type="primary">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="$router.push({path:'/home/addBusiness'})" type="primary">新增商家</el-button>
                </el-form-item>
                <el-form-item belong-to-admin>
                    <el-button @click="$refs['save-clue-price-dialog'].show()" type="primary">设置线索购买价格</el-button>
                </el-form-item>

                <el-form-item belong-to-admin>
                    <el-button @click="exportExcel()" type="primary">导出</el-button>
                </el-form-item>

            </el-form>
        </el-row>
        <el-row>
            <div element-loading-text="拼命加载中" style="background-color: #eee;min-height: 150px;" v-loading="loading">
                <div style="width: 100%;height: 100%;text-align: center;padding: 65px;"
                     v-show="datas.length==0 || loading">{{loading?'加载中...':'暂时没有数据哦！'}}
                </div>
                <el-card class='basic-margin' v-bind:key="index" v-for="(data,index) in datas">
                    <div :disable="data.state" class="arrow-down">
                        <span class="head-mark-font">{{data.state | businessStateFilter}}</span>
                    </div>
                    <el-row>
                        <img :src="baseImageUrl+data.businessIcon.split(',')[0]"
                             alt="" style="width:204px;height:144px;float:left;">
                        <el-col :span="12" style="padding:0px;padding-left:10px;">
                            <p>
                                <span style="font-size:20px;"><b>{{data.businessName}}</b></span>
                                <span class="label" style="margin-left:5px;background-color:#409EFF;"
                                      v-if="data.stickTime">已置顶</span>
                                <span class="label" style="margin-left:5px;background-color:rgba(255, 153, 0, 1);"
                                      v-if="data.businessCarMaster">已关联车大神</span>

                                <el-tooltip :content="'服务类型：'+data.serviceTag" class="item" effect="dark"
                                            placement="top">
                                    <div slot="content"><span>入驻方案明细：<br/><br/></span><span
                                            style="color:#E6A23C;" v-bind:key="index"
                                            v-for="(tag,index) in data.serviceTag">{{tag}}<br/></span></div>
                                    <span class="label" style="margin-left:5px;background-color:rgba(255, 153, 0, 1);"
                                          v-if="data.serviceLevel">
                                  {{data.serviceName+' '+data.servicePrice}} 元/年
                                </span>
                                </el-tooltip>
                                <span class="label" style="margin-left:5px;background-color:#67C23A;"
                                      v-if="data.orderStatus">{{data.orderStatus | businessOrderFilter}}</span>

                            </p>
                            <p>公司地址：{{data.areaName +' '+ data.address}}</p>
                            <p>服务类型：{{data.serviceType}}</p>
                            <p>对接人：{{data.abutmentPersonName}}（{{data.abutmentPhone}}）</p>
                            <p>入驻时间：{{data.createTime | dateFormat}} 创建人：({{data.createPerson}})</p>
                        </el-col>
                        <el-col :span="6">
                            <el-col :span="24" style="padding:0px;padding-left:10px;text-align:right;">
                                <el-button @click="changeState(data.id,0)" type="danger"
                                           v-if="data.state==1 || data.state==3">下架
                                </el-button>
                                <el-button @click="changeState(data.id,1)" type="success" v-if="data.state!=1">上架
                                </el-button>
                                <el-dropdown trigger="click" v-if="loginInfo.loginPath=='channel'">
                                    <el-button type="primary">
                                        更多菜单<i class="el-icon-caret-bottom el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item
                                                @click.native.prevent="$router.push({name:'编辑商家', params: { id: data.id }})">
                                            编辑
                                        </el-dropdown-item>
                                        <el-dropdown-item
                                                @click.native.prevent="stickTopBusiness(data.id,data.stickTime?false:true)">
                                            {{data.stickTime?'取消置顶':'置顶'}}
                                        </el-dropdown-item>
                                        <el-dropdown-item @click.native.prevent="toReleaseProduct(data.id)">代发商品
                                        </el-dropdown-item>
                                        <el-dropdown-item @click.native.prevent="toReleaseActive(data.id)">代发活动
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <el-dropdown trigger="click" v-else-if="loginInfo.loginPath=='cxh'">
                                    <el-button type="primary">
                                        更多菜单<i class="el-icon-caret-bottom el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item
                                                @click.native.prevent="$router.push({name:'编辑商家', params: { id: data.id }})">
                                            编辑
                                        </el-dropdown-item>
                                        <el-dropdown-item
                                                @click.native.prevent="stickTopBusiness(data.id,data.stickTime?false:true)">
                                            {{data.stickTime?'取消置顶':'置顶'}}
                                        </el-dropdown-item>
                                        <el-dropdown-item @click.native.prevent="delBusiness(data.id)">删除
                                        </el-dropdown-item>
                                        <el-dropdown-item @click.native.prevent="toReleaseProduct(data.id)">代发商品
                                        </el-dropdown-item>
                                        <el-dropdown-item @click.native.prevent="toReleaseActive(data.id)">代发活动
                                        </el-dropdown-item>
                                        <el-dropdown-item
                                                @click.native.prevent="showDialog(data.id,data.businessCarMaster)">关联车大神
                                        </el-dropdown-item>

                                    </el-dropdown-menu>
                                </el-dropdown>
                            </el-col>

                            <el-col style="text-align:right;margin-top:20px;">
                                <div class="grid-content bg-purple">
                                    <span style="color: #337ab7;">{{data.pageViewCount}}次浏览</span> |
                                    <router-link :to="{ name: '商家产品', params: { businessId: data.id }}">
                                        产品{{data.businessProductCount}}个
                                    </router-link>
                                    |
                                    <router-link :to="{ name: '商家活动', params: { businessId: data.id }}">
                                        活动{{data.businessActivityCount}}个
                                    </router-link>
                                    |<span style="color: #337ab7;"> {{data.calledCount}}次呼叫</span>

                                </div>
                            </el-col>
                        </el-col>
                    </el-row>
                    <el-row class="row-bg" type="flex">
                        <el-col :span="24">
                            <div class="grid-content bg-purple-light"></div>
                        </el-col>
                    </el-row>
                </el-card>
            </div>
        </el-row>

        <el-pagination :current-page.sync="currentPage" :total="total" class="basic-margin"
                       layout="total, prev, pager, next">
        </el-pagination>
        <save-merchant-dialog @handleSuccess="loadList" ref="saveMerchantDialog"></save-merchant-dialog>
        <save-clue-price-dialog ref="save-clue-price-dialog"></save-clue-price-dialog>

        <el-form :model="carMasterForm" :rules="rules" editAction="business/updateCarMasterAccount.action" label-width="125px"
                 ref="form" v-form>
            <el-dialog :visible.sync="dialogVisible" @close="handleClose" size="tiny" title="关联车大神">
                <el-form-item label="关联车大神：" prop="businessCarMaster">
                    <el-input v-model="carMasterForm.businessCarMaster"></el-input>
                </el-form-item>

                <span class="dialog-footer" slot="footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary">确 定</el-button>
          </span>
            </el-dialog>
        </el-form>
    </el-row>

</template>

<script>
import channelSelect from '@/components/channelSelect'
import BasicPager from '../../mixins/BasicPager'
import sxbUserModel from '@/framework/models/sxbUserModel'
import ChannelModel from '../../framework/models/channelModel'
import BusinessModel from '../../framework/models/businessModel'
import SaveMerchantDialog from './children/saveMerchantDialog'
import SaveCluePriceDialog from './children/saveCluePriceDialog'
import Config from '../../framework/configs/Config'

export default {
  name: 'business-list',
  extends: BasicPager,
  data: function () {
    let validateAccount = (rule, value, callback) => {
      if (!value || this.id) {
        callback()
        return
      }
      let listener = {
        success: function (dataInfo) {
          let datas = dataInfo.datas
          if (datas) {
            callback()
          } else {
            callback(new Error('不存在该车大神账号，请重新输入！'))
          }
        }
      }
      sxbUserModel.selectByAccountNumber(this, {
        accountNumber: value
      }, listener)
    }

    let validateBusiness = (rule, value, callback) => {
      if (!value) {
        callback()
        return
      }
      let _this = this
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.datas && !_this.oldBusinessCarMaster) {
            callback(new Error('已存在该用户，请重新输入！'))
          } else {
            callback()
          }
        }
      }
      BusinessModel.checkExistsBusiness(this, {
        accountNumber: value
      }, listener)
    }

    return {
      datas: [],
      isAdmin: false,
      loading: false,
      dialogVisible: false,
      validateAccount: validateAccount,
      validateBusiness: validateBusiness,
      total: 0,
      currentPage: 0,
      baseImageUrl: '',
      showChannels: [],
      clueChannels: [],
      oldBusinessCarMaster: null,
      carMasterForm: {
        id: null,
        businessCarMaster: null
      },
      rules: {
        businessCarMaster: [{
          validator: validateAccount,
          trigger: 'blur'
        }, {
          validator: validateBusiness,
          trigger: 'blur'
        }]
      },
      formInline: {
        merchantName: '',
        createTime: [],
        state: null,
        keyWord: '',
        showChannelId: null,
        clueChannelId: null
      }
    }
  },
  watch: {
    'formInline.showChannelId': function () {
      this.loadList()
    },
    'formInline.clueChannelId': function () {
      this.loadList()
    },
    currentPage: function () {
      this.loadList()
    }
  },
  created: function () {
    this.baseImageUrl = Config.imageUrl
    this.loadList()
    this.findAllChannels()
  },
  activated: function () {
    this.loadList()
  },
  methods: {
    channelIdsChange: function (channelId) {
      this.formInline.showChannelId = channelId
    },
    channelIdsChangeClue: function (channelId) {
      this.formInline.clueChannelId = channelId
    },
    exportExcel: function () {
      // 验证用户登录状态
      let userInfo = this.getLoginInfo()
      if (!userInfo) {
        this.$message('您没有登录哦！')
        return
      }

      let loginPath = userInfo.loginPath
      if (loginPath === 'channel') {
        this.$message('访问限制！')
        return
      }

      let id = userInfo.employeeId
      window.location.href = Config.baseUrl + 'business/exportExcel.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath
    },
    handleClose: function () {
      this.oldBusinessCarMaster = null
    },
    onEdited: function () {
      this.dialogVisible = false
      this.loadList()
    },
    showDialog: function (id, businessCarMaster) {
      this.carMasterForm.id = id
      this.carMasterForm.businessCarMaster = businessCarMaster

      this.oldBusinessCarMaster = businessCarMaster

      this.dialogVisible = true
    },
    toReleaseProduct: function (id) {
      this.$router.push({
        name: '添加产品',
        params: {
          'businessId': id
        }
      })
    },
    toReleaseActive: function (id) {
      this.$router.push({
        name: '添加活动',
        params: {
          businessId: id
        }
      })
    },
    stickTopBusiness: function (id, isTop) {
      this.$confirm(isTop ? '确认置顶?' : '取消置顶?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _this = this
        let params = {
          businessId: id,
          isStick: isTop
        }
        let listener = {
          success: function (dataInfo) {
            _this.$message({
              message: '修改成功！',
              type: 'success'
            })
            _this.loadList()
          }
        }
        BusinessModel.stickTopBusiness(_this, params, listener)
      })
    },
    changeState: function (id, state) {
      this.$confirm('确认修改状态?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _this = this
        let params = {
          businessId: id,
          state: state
        }
        let listener = {
          success: function (dataInfo) {
            _this.$message({
              message: '修改成功！',
              type: 'success'
            })
            _this.loadList()
          }
        }
        BusinessModel.updateBusinessState(_this, params, listener)
      })
    },
    delBusiness: function (id) {
      this.$confirm('确认删除该商家吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _this = this
        let params = {
          businessId: id
        }
        let listener = {
          success: function (dataInfo) {
            _this.$message({
              message: '删除成功！',
              type: 'success'
            })
            _this.loadList()
          }
        }
        BusinessModel.delBusiness(_this, params, listener)
      })
    },
    loadList: function () {
      let _this = this
      _this.loading = true
      let params = {
        start: _this.currentPage,
        length: 10,
        state: _this.formInline.state,
        showChannelId: _this.formInline.showChannelId,
        clueChannelId: _this.formInline.clueChannelId
      }
      if (_this.getLoginInfo().id) {
        params.channelId = _this.getLoginInfo().id
      }
      if (_this.formInline.keyWord) {
        params.keyWord = _this.formInline.keyWord
      }
      let createTime = _this.formInline.createTime
      if (createTime && createTime.length > 0 && createTime[0]) {
        params.startTime = createTime[0].getTime()
        params.endTime = createTime[1].getTime()
      }

      _this.loading = false

      let listener = {
        success: function (dataInfo) {
          let datas = dataInfo.data
          for (let i = 0, size = datas.length; i < size; i++) {
            let data = datas[i]
            let showChannels = data.showChannels

            if (!showChannels) {
              continue
            }
            let showChannelStr = ''
            for (var j = 0, showSize = showChannels.length; j < showSize; j++) {
              let channelItem = showChannels[j]
              if (!channelItem) {
                continue
              }

              if (j !== 0) {
                showChannelStr += ',' + channelItem.channelName
              } else {
                showChannelStr += channelItem.channelName
              }
            }
            data.showChannelStr = showChannelStr
          }

          for (let i = 0, size = datas.length; i < size; i++) {
            let data = datas[i]
            let clueChannels = data.clueChannels

            // 服务信息
            if (data.serviceLevel) {
              let serviceJSON = JSON.parse(data.serviceLevel)
              data.serviceName = serviceJSON.serviceName
              data.servicePrice = serviceJSON.servicePrice
              data.serviceTag = serviceJSON.serviceTag
            }

            if (!clueChannels) {
              continue
            }

            let clueChannelStr = ''
            for (var K = 0, channelSize = clueChannels.length; K < channelSize; K++) {
              let channelItem = clueChannels[K]
              if (!channelItem) {
                continue
              }

              if (K !== 0) {
                clueChannelStr += ',' + channelItem.channelName
              } else {
                clueChannelStr += channelItem.channelName
              }
            }
            data.clueChannelStr = clueChannelStr
          }
          _this.datas = datas
          _this.total = dataInfo.recordsTotal
        }
      }
      BusinessModel.findBusinesses(_this, params, listener)
    },
    findAllChannels: function () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          _this.showChannels = dataInfo.datas
          _this.clueChannels = dataInfo.datas
        }
      }
      ChannelModel.findAllChannels(_this, listener)
    }
  },
  components: {
    SaveMerchantDialog,
    SaveCluePriceDialog,
    channelSelect
  }
}

</script>
